import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'IssueFormLocationsController',
            IssueFormLocationsController
        );

    function IssueFormLocationsController() {}
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/locations/issue_form_locations.controller.ts